import React from 'react'

function BoxTitle(props) {
    return(
        <div className="box-title">
            <p>{props.title}</p>
        </div>
    )
}
export default BoxTitle;